import React from "react";
import "./Password.css";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

function Password() {
  const [currentPassword, setCurrentPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [repeatPassword, setRepeatPassword] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const navigate = useNavigate();

  const token = useSelector((state) => {
    return state.token;
  });

  const tokenBearer = token.token;

  const handlePassword = async (
    e,
    currentPassword,
    newPassword,
    repeatPassword
  ) => {
    e.preventDefault();
    try {
      const authAxios = axios.create({
        headers: {
          Authorization: `Bearer ${tokenBearer}`,
          ContentType: `application/json`,
        },
      });
      const response = await authAxios.post(
        `${process.env.REACT_APP_API_URL}/private/password`,
        {
          currentPassword,
          newPassword,
          repeatPassword,
        }
      );
      setSuccessMessage(response.data);
      setErrorMessage("");
      setCurrentPassword("");
      setNewPassword("");
      setRepeatPassword("");
      navigate("/");
    } catch (err) {
      setErrorMessage(err.response.data);
      setSuccessMessage("");
      setCurrentPassword("");
      setNewPassword("");
      setRepeatPassword("");
    }
  };

  return (
    <div>
      <div className="account-password section">
        <div className="container text-start">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1 col-12">
              <form
                onSubmit={(e) => {
                  handlePassword(
                    e,
                    currentPassword,
                    newPassword,
                    repeatPassword
                  );
                }}
                className="card password-form p-3"
              >
                <div className="card-body">
                  <div className="title">
                    <h3
                      style={{ fontFamily: `Corporate S Regular, sans-serif` }}
                    >
                      Change password
                    </h3>
                  </div>

                  <div className="form-group input-group">
                    <label
                      htmlFor="reg-fn"
                      style={{ fontFamily: `Corporate S Regular, sans-serif` }}
                    >
                      Current Password
                    </label>
                    <input
                      className="form-control"
                      type="password"
                      id="currentPassword"
                      required=""
                      value={currentPassword}
                      onChange={(e) => {
                        setCurrentPassword(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group input-group">
                    <label
                      htmlFor="reg-fn"
                      style={{ fontFamily: `Corporate S Regular, sans-serif` }}
                    >
                      New Password
                    </label>
                    <input
                      className="form-control"
                      type="password"
                      id="newPassword"
                      required=""
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group input-group">
                    <label
                      htmlFor="reg-fn"
                      style={{ fontFamily: `Corporate S Regular, sans-serif` }}
                    >
                      Repeat Password
                    </label>
                    <input
                      className="form-control"
                      type="password"
                      id="repeatPassword"
                      required=""
                      value={repeatPassword}
                      onChange={(e) => {
                        setRepeatPassword(e.target.value);
                      }}
                    />
                  </div>
                  <div className="d-flex flex-wrap justify-content-between bottom-content"></div>
                  {errorMessage && <p className="mt-2">{errorMessage}</p>}
                  {successMessage && (
                    <p className="passwordError mt-2">{errorMessage}</p>
                  )}
                  <div className="button">
                    <button
                      className="btn"
                      type="submit"
                      style={{
                        backgroundColor: `rgb(213, 179, 117)`,
                        fontFamily: `Corporate S Regular, sans-serif`,
                      }}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Password;
